// Types
import type { TApiHttpClientRequestConfig } from '~/misc/resource/types';
import type { IPatchModel, TNewPatch, TPaginatedPatches, TPatch } from '~/misc/patch/types';
import type { TManagerCompanyPatchesPayload } from '~/modules/manager/types';

// Models
import { ManagerResource } from '~/modules/manager/resource/manager-resource.model';
import { ManagerPatchModel } from '~/modules/manager/models/patch';

export class ManagerPatchUserResourceAdapter extends ManagerResource implements IPatchModel {
  protected model: ManagerPatchModel = new ManagerPatchModel();

  constructor(protected companyId: number) {
    super();
  }

  index(
    payload?: TManagerCompanyPatchesPayload,
    requestConfig?: TApiHttpClientRequestConfig
  ): Promise<TPaginatedPatches> {
    return this.model.index(this.companyId, payload, requestConfig);
  }

  store(
    payload: TNewPatch,
    requestConfig?: TApiHttpClientRequestConfig | undefined
  ): Promise<TPatch> {
    return this.model.store(this.companyId, payload, requestConfig);
  }

  update(
    patchId: number,
    payload: TNewPatch,
    requestConfig?: TApiHttpClientRequestConfig
  ): Promise<TPatch> {
    return this.model.update(patchId, payload, requestConfig);
  }

  destroy(patchId: number, requestConfig?: TApiHttpClientRequestConfig): Promise<void> {
    return this.model.destroy(patchId, requestConfig);
  }
}
